import api from '../../api'

export default {
  name: 'Forgot',
  data: () => {
    return {
      email: '',
      isEmailWasSent: false
    }
  },
  computed: {
    isInvalid () {
      return Object.values(this.fields).some(x => !x.valid)
    }
  },
  methods: {
    sendEmail () {
      if (this.isInvalid) return

      const router = this.$router
      api.post.resetPassword(this.email)
        .then(() => {
          this.isEmailWasSent = true
          setTimeout(() => router.push('/login'), 8000)
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    }
  }
}
